/* eslint-disable @typescript-eslint/no-explicit-any */
import { format, addDays, /* getWeeksInMonth, getWeekOfMonth, */ startOfWeek } from 'date-fns';
import { es } from 'date-fns/locale';
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const weeklyList = () => {
    const getDaysInWeek = (start: Date) => {
        const firstDayOfWeek = addDays(startOfWeek(start), 1);
        return {
            id:
                addDays(firstDayOfWeek, 0).getUTCDate().toString() +
                addDays(firstDayOfWeek, 6).getUTCDate().toString() +
                start.getMonth(),
            start: format(addDays(firstDayOfWeek, 0), 'yyyy-MM-dd', { locale: es }),
            end: format(addDays(firstDayOfWeek, 6), 'yyyy-MM-dd', { locale: es }),
            label:
                format(addDays(firstDayOfWeek, 0), 'dd/MM EEEE', { locale: es }) +
                ' - ' +
                format(addDays(firstDayOfWeek, 6), 'dd/MM EEEE', { locale: es }),
        };
    };

    let day = new Date();
    day = addDays(startOfWeek(day), 1); // present week
    day = addDays(startOfWeek(day), -5); // last week
    //const countWeeks = getWeeksInMonth(day) - getWeekOfMonth(day);
    const countWeeks = 2; // last week, present week, 4 weeks after
    const weeks = [];
    for (let i = 0; i < countWeeks + 1; i++) {
        weeks.push(getDaysInWeek(day));
        day = addDays(day, 7);
    }
    return weeks;
};
